/**
 * Copy for the shared profile layout (MYN-217, `docs/specs/features/profile-redesign/`):
 * the section-card Edit action, the side-panel editor, and the startup
 * completion menu. Its own file because `ui-strings.ts` is past the 600-line cap.
 */
export const PROFILE_LAYOUT_STRINGS = {
  EDIT: 'Edit',
  ADD: 'Add',
  SAVE: 'Save Changes',
  SAVING: 'Saving…',
  CANCEL: 'Cancel',
  SAVE_SUCCESS: 'Your changes have been saved.',
  SAVE_ERROR: 'We could not save your changes. Please try again.',
  DISCARD_TITLE: 'Discard changes?',
  DISCARD_BODY: 'Your unsaved changes in this section will be lost.',
  DISCARD_CONFIRM: 'Discard',
  DISCARD_KEEP: 'Keep editing',
  // Summary at the top of a side panel whose Save was refused (FR-189).
  ERROR_SUMMARY_TITLE: (count: number) =>
    count === 1 ? '1 field needs your attention' : `${count} fields need your attention`,
  // The reason shown for a repeatable list whose entries failed (the entries carry their own text).
  ERROR_SUMMARY_ROW_REASON: 'Check the entries below',
  EDIT_SECTION_LABEL: (section: string) => `Edit ${section}`,
  ITEMS_LEFT: (count: number) => `${count} ${count === 1 ? 'item' : 'items'} left`,
  PROFILE_COMPLETE: 'Profile complete',
  // First save of a new investor or partner profile (FR-181).
  SETUP_TITLE: 'Set up your profile',
  SETUP_BODY:
    'Fill in your profile once to get started. After that you can edit each section on its own.',
  SETUP_ACTION: 'Set up profile',
  NOT_SET_UP: 'This profile has not been set up yet.',
  // A header number with no value keeps its column (client feedback 2026-10-15).
  EMPTY_STAT: '-',
  // A card field with no value.
  NOT_PROVIDED: 'Not provided',
  NOT_ADDED_YET: 'Not added yet',
  ADD_LINK: 'Add link',
  VIEW: 'View',
  WATCH: 'Watch',
} as const;
